import {QueryList} from '@angular/core';
import {ViewChildren} from '@angular/core';
import {MatCheckbox, MatPaginator} from '@angular/material';
import {ConfirmationResult} from './../../../../Messages/confirm-sheet/confirmation-sheet.component';
import {DTOConversationMessage, DTOConversation} from './../../../../api/WickedApiClient';
import {ConversationService} from './../../../../Services/conversationService';
import {MainService} from 'src/app/Services/service.service';
import {Component, OnInit, Output, EventEmitter, ElementRef} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {environment} from 'src/environments/environment';

@Component({
  selector: 'vng-chat-group-list',
  templateUrl: './group-list.component.html',
  styleUrls: ['./group-list.component.scss']
})
export class GroupListComponent implements OnInit {

  public perPage: number = 24; //count convs per page 0 is for all
  public page: number = 0;

  conversations: DTOConversation[] = [];
  images: {} = {};
  loading: boolean = false;
  noConversationsInfo: boolean = false;

  @ViewChildren('convList', {read: ElementRef}) convList;
  @ViewChildren('checboxList') checboxList;
  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();

  public refreshingLastList: boolean = false

  constructor(private mainService: MainService, private conversationService: ConversationService, private router: Router, private route: ActivatedRoute) {
    this.route.queryParams.subscribe(params => {
      const paramPage = params['page'] - 1;
      if(paramPage) this.page = paramPage;
    });
  }

  @Output() activeGroupChanged = new EventEmitter<Group>()

  private currentUserIsAdmin: boolean = false;
  public activeGroup: Group;
  private userNick: number;

  ngOnInit() {
    this.userNick = this.mainService.userService.getUserId();

    this.currentUserIsAdmin = this.mainService.userService.isAdmin();
    const lastConversations = this.conversationService.getLastConversations();
    //new
    if(lastConversations) {
      this.refreshingLastList = true;
      this.conversations = lastConversations;
      this.reloadConversations(false);
    } else {
      this.reloadConversations();
    }
    this.conversationService.getConversationsCount().then(result => {
      this._allConversationsCount = result;
    })
  }

  ngAfterViewInit() {
    this.convListArray = this.convList.toArray();
    this.convList.changes.subscribe(t => {
      this.ngForRendred();
    })
    this.checboxList.changes.subscribe(t => {
      this.ngForRendredChecboxes();
    })
  }

  ngForRendred() {
    this.convListArray = this.convList.toArray();
  }
  ngForRendredChecboxes() {
    this.checboxListArray = this.checboxList.toArray();
  }

  showDemoAdInfo(conversation: DTOConversation) {
    return conversation.demoAdvertisement && this.currentUserIsAdmin;
  }

  activateGroup(conversation) {

    this.activeGroup = conversation;
    this.activeGroupChanged.emit(this.activeGroup);

  }
  navigateToAdv(e, advId) {
    e.stopPropagation();
    this.mainService.route.navigate([`adv-detail/${advId}`]);
  }

  resolveConversationSenderNick(conversation: DTOConversation) {
    if(conversation.senderId == this.userNick) {
      return "You"
    }
    else return conversation.senderNick;
  }

  deleteConversation(e, conversationId: number, arrayIndex: number) {
    e.stopPropagation();
    this.mainService.showConfirm("Are you sure?", "300px").then((res) => {
      if(res == ConfirmationResult.Yes) {
        const thisConvElement = document.getElementsByClassName('conversation-' + conversationId)[0];
        thisConvElement.classList.add("deleting");
        this.conversationService.deleteConversation(conversationId, arrayIndex).then(res => {
          thisConvElement.remove();
          this.mainService.showInformation("Conversation deleted");
        }).catch(err => {
          this.mainService.showError(err)
        })
      }
    })
  }

  private _pageEvent;
  public get pageEvent() {
    return this._pageEvent;
  }

  public set pageEvent(value) {
    this._pageEvent = value;
    this.page = value.pageIndex;
    this.addUrlPageParam(value.pageIndex + 1);
    this.reloadConversations();
  }
  private pageChange(e) {
    window.scroll(0, 0);
  }

  private addUrlPageParam(value) {
    const queryParams: Params = {page: value};

    this.router.navigate(
      [],
      {
        relativeTo: this.route,
        queryParams: queryParams,
        queryParamsHandling: 'merge', // remove to replace all query params by provided
      });
  }

  private _allConversationsCount: number = 0;

  public get allConversationsCount() {
    return this._allConversationsCount;
  }

  private reloadConversations(loading = true) {
    this.loading = loading;
    this.conversationService.getConversations(this.perPage, this.page).then(result => {
      this.loading = false;
      this.noConversationsInfo = (result.conversations == null || result.conversations.length == 0);
      this.conversations = result.conversations;
      this.conversations.forEach((conversation) => {
        conversation.messages.forEach((message) => {
          if(message.images.length > 0) {
            if(this.images[conversation.conversationId] == null) {
              this.images[conversation.conversationId] = {}
            }
            this.images[conversation.conversationId][message.conversationMessageId] = this.prepareImages(message);
          }
        })
      });
      this.refreshingLastList = false;
    }).catch(error => {
      this.loading = false;
      this.mainService.showError(error)
    })
  }

  //new

  prepareImages(message: DTOConversationMessage): {small: string, medium: string, big: string}[] {
    var images = message.images.map(img => {
      return {
        small: `${environment.apiBaseUrl}/FileGet/${img.fileName}`,
        medium: `${environment.apiBaseUrl}/FileGet/${img.fileName}`,
        big: `${environment.apiBaseUrl}/FileGet/${img.fileName}`
      }
    });

    return images;
  }

  setReadedMessages(conversation: DTOConversation): void {
    this.conversationService.setReadedMessages(conversation.conversationId, conversation.messages.map(c => c.conversationMessageId));
  }

  private _selectedConvCount: number = 0;
  private convListArray: Array<ElementRef> = [];
  private checboxListArray: Array<MatCheckbox> = [];
  private selectAllCheckbox = false;

  get selectedConvCount() {
    //this._selectedConvCount = document.getElementsByClassName("isSelected").length;
    this._selectedConvCount = 0
    this.checboxListArray.forEach(e => {
      if(e['checked'] == true) {
        this._selectedConvCount++
      }
    });
    return this._selectedConvCount;
  }

  selectAllConversations(e) {
    if(e.checked) {

      this.checboxListArray.forEach(e => {
        e['checked'] = true;
      });
    } else {

      this.checboxListArray.forEach(e => {
        e['checked'] = false;
      });
    }
  }
  selectConversation(e, i) {
    const convClassList = this.convListArray[i].nativeElement.classList;
    if(e.checked) {
    } else {
    }
    convClassList.toggle('isSelected');
    if(this.selectedConvCount == this.convListArray.length) {
      this.selectAllCheckbox = true;
    } else {
      this.selectAllCheckbox = false;
    }
  }
  deleteSelectedConv() {
    this.mainService.showConfirm("Are you sure to delete " + this.selectedConvCount + " conversations ?", "300px").then((res) => {
      if(res == ConfirmationResult.Yes) {
        this.loading = true;
        let tmpDeletedCount = 0;
        this.checboxListArray.forEach(e => {
          if(e['checked']) {
            this.conversationService.deleteConversation(parseInt(e.id)).then(res => {
              tmpDeletedCount++;
              if(this.selectedConvCount == tmpDeletedCount) {
                this.mainService.showInformation("Conversations deleted");
                this.reloadConversations();
              }
            }).catch(err => {
              this.mainService.showError(err)
            })
          }
        });
      }
    })
  }
}
export interface Group {
  groupName: string, groupImageUrl: string, lastMessage: string
}
